import React, { useEffect, useRef, useState } from "react";
import downIcon from "../../../asset/images/download-orange-arrow.svg";
import filter from "../../../asset/images/preference-horizontal.svg";
import { Modal } from "react-bootstrap";
import { Dealer_Mapping } from "../../../Configuration/API_URL";
import infoIcon from "../../../asset/images/info-circle.svg";
import { batchIdFormatter, batchIdPaste, decryptData, formatDate, noDataFound, toSentenceCase } from "../../../CommonMethhods/CommonMethods";
import { toast } from "react-toastify";
import axiosInstance from "../../../CommonMethhods/axiosInstance";
import { useDebounce } from "../../../Components/useDebounce";
import moment from "moment";
import Loader from "../../../Components/Common/Loader";
import SmallLoader from "../../../Components/Common/smallLoader";
import CustomTradeDate from "../../../CommonMethhods/CustomDate";
import HistoryPreview from "./HistoryPreview";

function CheckerMyRequest({ setActiveTab, setViewRequest }) {
  const [search, setSearch] = useState("");
  const [filterModal, setFilterModal] = useState(false);
  const [typeFilter, setTypeFilter] = useState("all");
  const [statusFilter, setStatusFilter] = useState("all");
  const [selectedSR, setSelectedSR] = useState(null);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [loader, setLoader] = useState(false);
  const [btnLoader, setBtnLoader] = useState(null);
  const reviewSectionRef = useRef(null);
  const [historyData, setHistoryData] = useState([]);
  const [downloadLoader, setDownloadLoader] = useState(false);
  const [selectedBatch, setSelectedBatch] = useState(null);
  const resetBtnRef = useRef(null);
  const applyBtnRef = useRef(null);
  const headerRefs = useRef([]);
  const allTypeRef = useRef(null);


  const debouncedValue = useDebounce(search, 1000);

  useEffect(() => {
    getRequestHistory(
      "grid",
      debouncedValue,
      fromDate,
      toDate,
      statusFilter,
      typeFilter
    );
  }, [debouncedValue]);

  const showFilterModal = () => {
    setFilterModal(true);
  };

  const handleViewButton = (batch) => {
    setSelectedBatch(batch);

    reviewSectionRef.current?.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  };

  const getRequestHistory = async (
    format = "grid",
    searchText = "",
    from = fromDate,
    to = toDate,
    status = statusFilter,
    type = typeFilter
  ) => {

    if (format === "grid") {
      setLoader(true);
    } else {
      setDownloadLoader(true);
    }

    try {
      const queryParams = new URLSearchParams({
        format,
        status: status?.toLowerCase() === "all" ? "all" : status.toLowerCase(),
        type: type.toLowerCase() || "all",
        fromDate: from
          ? moment(from, "DD-MM-YYYY").format("YYYY-MM-DD")
          : "",
        toDate: to
          ? moment(to, "DD-MM-YYYY").format("YYYY-MM-DD")
          : "",
        batchIdRef: searchText,
      });
      const response = await axiosInstance.get(
        `${Dealer_Mapping.checkerMyRequest}?${queryParams}`,
      );

      const decrypted = JSON.parse(decryptData(response.data));

      console.log(decrypted, "decryptedRequest");

      if (decrypted?.status === 0) {
        if (format === "grid") {
          setHistoryData(decrypted.data);
        } else {
          toast.success(decrypted?.message)
          window.open(decrypted?.data?.url, "_self", "noopener,noreferrer");
        }

      } else {
        setHistoryData([]);
        toast.error(decrypted.message);
      }
    } catch (error) {
      const decryptedError = JSON.parse(
        decryptData(error.response.data)
      );
      toast.error(decryptedError.message);
    } finally {
      if (format === "grid") {
        setLoader(false);
      } else {
        setDownloadLoader(false);
      }
    }
  };

  const currentDate = new Date();
  const yyyy = currentDate.getFullYear();
  let mm = currentDate.getMonth() + 1;
  let dd = currentDate.getDate();
  if (dd < 10) dd = "0" + dd;
  if (mm < 10) mm = "0" + mm;
  const FormatedDate = dd + "/" + mm + "/" + yyyy;
  const DateReverse = FormatedDate.split("/").reverse().join("-");

  const handleResetFilter = () => {
    setFromDate("");
    setToDate("");
    setTypeFilter("all");

    getRequestHistory(
      "grid",
      search,
      "",
      "",
      statusFilter,
      "all"
    );
  };

  const handleFilterKeyDown = (e) => {
    if (e.key !== "Enter") return;

    if (e.target instanceof HTMLButtonElement) {
      return;
    }

    e.preventDefault();
    handleApplyFilter();
  };

  useEffect(() => {
    if (selectedSR) {
      reviewSectionRef.current?.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  }, [selectedSR]);

  const handleApplyFilter = (selectedType = typeFilter) => {
    setSelectedBatch(null);

    if (!fromDate && !toDate) {
      getRequestHistory(
        "grid",
        search,
        "",
        "",
        statusFilter,
        selectedType
      );
      setFilterModal(false);
      return;
    }

    if (!fromDate || !toDate) {
      toast.error("Please select both From Date and To Date");
      return;
    }

    const from = moment(fromDate, "DD-MM-YYYY", true);
    const to = moment(toDate, "DD-MM-YYYY", true);
    const today = moment().startOf("day");

    if (!from.isValid() || !to.isValid()) {
      toast.error("Please enter valid dates");
      return;
    }

    if (from.isAfter(today)) {
      toast.error("From Date cannot be a future date");
      return;
    }

    if (to.isAfter(today)) {
      toast.error("To Date cannot be a future date");
      return;
    }

    if (to.isBefore(from)) {
      toast.error("To Date cannot be earlier than From Date");
      return;
    }

    if (to.diff(from, "days") > 31) {
      toast.error("Date range should not exceed 1 month");
      return;
    }

    getRequestHistory(
      "grid",
      search,
      fromDate,
      toDate,
      statusFilter,
      selectedType
    );

    setFilterModal(false);
  };
  const isDownloadDisabled = historyData?.length === 0;

  const handleCloseFilter = () => {
    setTypeFilter("all")
    setFromDate("");
    setToDate("");
    setFilterModal(false);
  };

  const getStatusClass = (status = "") => {
    switch (status.toLowerCase()) {
      case "approved":
        return "status-approved";
      case "rejected":
        return "status-rejected";
      case "partial":
        return "status-partial";
      default:
        return "";
    }
  };
  useEffect(() => {
    if (filterModal) {
      allTypeRef.current?.focus();
    }
  }, [filterModal]);

  const typeRefs = useRef([]);

  const typeOptions = ["all", "single", "bulk"];

  const handleTypeKeyDown = (e, index) => {
    let nextIndex = index;

    switch (e.key) {
      case "ArrowRight":
        e.preventDefault();
        nextIndex = (index + 1) % typeOptions.length;
        setTypeFilter(typeOptions[nextIndex]);
        typeRefs.current[nextIndex]?.focus();
        return;

      case "ArrowLeft":
        e.preventDefault();
        nextIndex =
          (index - 1 + typeOptions.length) % typeOptions.length;
        setTypeFilter(typeOptions[nextIndex]);
        typeRefs.current[nextIndex]?.focus();
        return;

      case "Enter":
      case " ":
        e.preventDefault();

        const selectedType = typeOptions[index];

        setTypeFilter(selectedType);

        handleApplyFilter(selectedType);

        return;

      default:
        return;
    }
  };

  const handleFooterKeyDown = (e) => {
    if (e.key === "ArrowRight") {
      e.preventDefault();
      applyBtnRef.current?.focus();
      return;
    }

    if (e.key === "ArrowLeft") {
      e.preventDefault();
      resetBtnRef.current?.focus();
      return;
    }

    if (e.key === "Enter") {
      e.stopPropagation();
      return;
    }
  };

  const handleHeaderKeyDown = (e, index) => {
  switch (e.key) {
    case "ArrowRight":
      e.preventDefault();
      headerRefs.current[Math.min(index + 1, headerRefs.current.length - 1)]?.focus();
      break;

    case "ArrowLeft":
      e.preventDefault();
      headerRefs.current[Math.max(index - 1, 0)]?.focus();
      break;

    case "Enter":
    case " ":
      e.preventDefault();
      headerRefs.current[index]?.click();
      break;

    default:
      break;
  }
};

  return (
    <>
      <div className="off-market-main">
        <div className="ckr-page new-upload">

          {selectedBatch && (
            <div
              className="wrap-all-tabs history-preview"
              ref={reviewSectionRef}
            >
              <HistoryPreview
                batch={selectedBatch}
                onClose={() => setSelectedBatch(null)}
              />
            </div>
          )}

          <div className="ckr-section history-table">
            <div className="ckr-section-header">
              <p className="ckr-section-title">Request History</p>

              <div className="d-flex align-items-center header-filter">

                <div className="filter-options offmark-filter">
                  <div className="dropdown-filter focusable-filter">
                    <select
                      size="lg"
                      aria-label="Default select example"
                      value={statusFilter}
                      onChange={(e) => {
                        setSelectedBatch(null);
                        const value = e.target.value;
                        setStatusFilter(value);
                        getRequestHistory(
                          "grid",
                          search,
                          fromDate,
                          toDate,
                          value,
                          typeFilter
                        );
                      }}
                    >
                      <option value="">All</option>
                      <option value="approved">Approved</option>
                      <option value="rejected">Rejected</option>
                      <option value="partial">Partial</option>
                    </select>
                  </div>
                </div>

                 <div className="filter-wrapper focusable-filter" 
                  tabIndex={0} 
                  ref={(el) => (headerRefs.current[1] = el)}
                  role="button"
                  onClick={showFilterModal}
                  onKeyDown={(e) => handleHeaderKeyDown(e, 1)}>
                    <img src={filter} alt="filter" />
                  </div>
                <div className="ckr-search-box focusable-filter">
                  <i className="fa fa-search" />
                  <input
                  ref={(el) => (headerRefs.current[2] = el)}
                    onKeyDown={(e) => handleHeaderKeyDown(e, 2)}
                    type="text"
                    placeholder="Search by SR"
                    value={search}
                    maxLength={10}
                    onChange={(e) => {
                      setSelectedBatch(null);
                      setSearch(batchIdFormatter(e?.target?.value))
                    }}
                    onPaste={() => {
                      setSelectedBatch(null);
                      batchIdPaste(10)
                    }}
                  />
                </div>

                <div className={`wrap-down-btn focusable-filter ${isDownloadDisabled ? "disabled-btn-download" : ""}`}
                 role="button"
                //  disabled={isDownloadDisabled}
                  tabIndex={isDownloadDisabled ? -1 : 0}
                  onClick={() =>{
                     if (isDownloadDisabled) return;
                  
                    getRequestHistory(
                      "file",
                      search,
                      fromDate,
                      toDate,
                      statusFilter,
                      typeFilter
                    )}
                  }
                  ref={(el) => (headerRefs.current[3] = el)}
                  onKeyDown={(e) => handleHeaderKeyDown(e, 3)}>

                  {downloadLoader ?
                    <SmallLoader />
                    :
                    <>
                      <img src={downIcon} alt="download-icon" />

                      <button
                        type="button"
                        className={`download-template ${isDownloadDisabled ? "disabled-text" : ""}`}
                        disabled={isDownloadDisabled}>DOWNLOAD</button>
                    </>}
                </div>

              </div>
            </div>
            <div className="ckr-table-wrapper cdm-table">
              {loader ?
                <div className="loader-alignment">
                  <Loader />
                </div>
                :
                historyData?.length > 0 ?
                  <table className="ckr-table draft-maker">
                    <thead>
                      <tr>
                        <th>SR</th>
                        <th>Request Date</th>
                        <th>SR Type</th>
                        <th>Total</th>
                        <th>Status</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {historyData.map((data) => (
                        <tr
                          key={data?.id}
                          className={selectedSR?.id === data?.id ? "ckr-active-row" : ""}
                        >
                          <td>{data?.batchId || "-"}</td>
                          <td>{formatDate(data?.requestDate) || "-"}</td>
                          <td>
                            {data?.batchId?.toUpperCase()?.startsWith("BLK") ? "Bulk" : "Single"}
                          </td>
                          <td>{data.count || 0}</td>
                          <td>
                            {data?.status ? (
                              <span className={getStatusClass(data?.status)}>
                                {toSentenceCase(data?.status)}
                              </span>
                            ) : (
                              "-"
                            )}
                          </td>
                          <td>
                            <div className="view-btn">
                              <button
                                className="submit-btns-view"
                                onClick={() => handleViewButton(data)}
                              >
                                {btnLoader === data?.id ?
                                  <SmallLoader />
                                  :
                                  <>
                                    VIEW DETAILS
                                  </>
                                }
                              </button>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  :
                  <div className="step-content report-error-message">
                    {noDataFound()}
                  </div>
              }
            </div>
          </div>
        </div>
      </div>

      <Modal
        show={filterModal}
        onHide={() => setFilterModal(false)}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="inactive-modal setting-model cdm-date-modal"
        backdrop="static"
        keyboard={true}
      >
        <Modal.Header className="mb-4 modal-header">
          <Modal.Title id="contained-modal-title-vcenter modal-title">
            <div className="figure-inlac header-pnl">
              <span className="header-title">Filters</span>
            </div>
          </Modal.Title>
          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={handleCloseFilter}
          >
            <span className="icon-close"></span>
          </button>
        </Modal.Header>
        <Modal.Body>
          <div className="table-responsive scroll-table model-top-active-table"
            onKeyDown={handleFilterKeyDown}>
            <span className="body-title-main">Select Type</span>
            <div className="type-wrapper"
              role="radiogroup"
              aria-label="Select Type">
              <button
                className={`type-button ${typeFilter === "all" ? "active" : ""
                  }`}
                type="button"
                role="radio"
                aria-checked={typeFilter === "all"}
                ref={allTypeRef}
                onKeyDown={(e) => handleTypeKeyDown(e, 0)}
                onClick={() => setTypeFilter("all")}
              >
                All Type
              </button>

              <button
                role="radio"
                aria-checked={typeFilter === "single"}
                ref={(el) => (typeRefs.current[1] = el)}
                onKeyDown={(e) => handleTypeKeyDown(e, 1)}
                className={`type-button ${typeFilter === "single" ? "active" : ""}`}
                type="button"
                onClick={() => setTypeFilter("single")}
              >
                Single
              </button>

              <button
                role="radio"
                aria-checked={typeFilter === "bulk"}
                ref={(el) => (typeRefs.current[2] = el)}
                onKeyDown={(e) => handleTypeKeyDown(e, 2)}
                className={`type-button ${typeFilter === "bulk" ? "active" : ""}`}
                type="button"
                onClick={() => setTypeFilter("bulk")}
              >
                Bulk
              </button>
            </div>
            <span className="body-title-main">Custom Date Range</span>

            <div className="date-wrapper">
              <div className="form-group">
                <label htmlFor="" className="form-label">
                  From Date<span className="manadate-mark">*</span>

                </label>
                <div>
                  <CustomTradeDate
                    idPrefix="fromDate"
                    value={fromDate}
                    onChange={(date) => {
                      setFromDate(date);
                    }}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        e.preventDefault();
                        handleApplyFilter();
                      }
                    }}
                    maxDate={toDate || DateReverse}
                  />
                </div>
              </div>
              <div className="form-group">
                <label htmlFor="" className="form-label">
                  To Date<span className="manadate-mark">*</span>
                </label>
                <div>
                  <CustomTradeDate
                    idPrefix="toDate"
                    value={toDate}
                    onChange={(date) => {
                      setToDate(date);
                    }}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        e.preventDefault();
                        handleApplyFilter();
                      }
                    }}
                    minDate={fromDate}
                    maxDate={DateReverse}
                  />
                </div>
              </div>
            </div>

            <div className="info-banner">
              <img src={infoIcon} alt="info icon" />
              <span className="banner-text">Please select a date range where difference between From date and To date is less than 1 month</span>
            </div>

            <div className="footer-actions modal-footer">
              <button type="button"
                ref={resetBtnRef} className="back-btn" onClick={handleResetFilter}
                onKeyDown={handleFooterKeyDown}
              >RESET</button>
              <button type="button"
                ref={applyBtnRef}
                className="submit-btns"
                onClick={() => handleApplyFilter()}
                onKeyDown={handleFooterKeyDown}>
                APPLY
              </button>
            </div>

          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default CheckerMyRequest;
